module.exports = __webpack_public_path__ + "static/media/usdc.241591f3.svg";